import { ChangeEvent } from 'react';

/**
 * Hook para formatação de telefone brasileiro
 * Formato: (XX) XXXXX-XXXX
 *
 * @example
 * ```tsx
 * const { phoneValue, handlePhoneChange } = usePhoneMask();
 *
 * <Input
 *   value={phoneValue}
 *   onChange={handlePhoneChange}
 * />
 * ```
 */
export const usePhoneMask = (_initialValue: string = '') => {
  const formatPhone = (value: string): string => {
    const numbers = value.replace(/\D/g, '');

    if (numbers.length <= 2) {
      return numbers;
    }
    if (numbers.length <= 7) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    }
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
  };

  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhone(e.target.value);
    e.target.value = formatted;
    return e;
  };

  return {
    formatPhone,
    handlePhoneChange,
  };
};
